'use memo';

import { createFileRoute } from '@tanstack/react-router';
import Icon from '@/components/Icon/Icon';
import { Text } from '@/components/Typography';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { MyClockingSummaryCard } from './-components/MyClockingSummaryCard';
import { MyDevicesSummaryCard } from './-components/MyDevicesSummaryCard';
import { MyEquipmentSummaryCard } from './-components/MyEquipmentSummaryCard';
import { MyPaySlipSummaryCard } from './-components/MyPaySlipSummaryCard';
import { MySoftwareSummaryCard } from './-components/MySoftwareSummaryCard';
import { MyWorkScheduleSummaryCard } from './-components/MyWorkScheduleSummaryCard';
export const Route = createFileRoute('/_individual/individual/portal/lookup/')({
  component: LookupPage
});
function LookupPage() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'individualPages.home.lookup'
  });
  return <div className="min-h-0 flex-1 overflow-auto bg-neutral-bottom-fill">
      <div className="min-h-full bg-blue-50/30">
        <div className="mx-auto max-w-[1280px] px-4 py-6 md:px-[100px] md:py-10">
          <div className="mx-auto flex w-full max-w-[800px] flex-col gap-6">
            <div className="flex items-center gap-2">
              <div className="flex h-11 w-11 items-center justify-center rounded-sm bg-primary-muted-fill">
                <Icon iconName="Eye" className="h-7 w-7 text-primary-on-muted-fill" inheritColor />
              </div>
              <Text as="h2" variant="h2">
                {t('title')}
              </Text>
            </div>
            <MyClockingSummaryCard />
            <MyWorkScheduleSummaryCard />
            <MyPaySlipSummaryCard />
            <MyDevicesSummaryCard />
            <MySoftwareSummaryCard />
            <MyEquipmentSummaryCard />
          </div>
        </div>
      </div>
    </div>;
}